/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdMedals200Ok
 */
export interface GetCorporationsCorporationIdMedals200Ok {
    /**
     * created_at string
     * @type {Date}
     * @memberof GetCorporationsCorporationIdMedals200Ok
     */
    createdAt: Date;
    /**
     * ID of the character who created this medal
     * @type {number}
     * @memberof GetCorporationsCorporationIdMedals200Ok
     */
    creatorId: number;
    /**
     * description string
     * @type {string}
     * @memberof GetCorporationsCorporationIdMedals200Ok
     */
    description: string;
    /**
     * medal_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdMedals200Ok
     */
    medalId: number;
    /**
     * title string
     * @type {string}
     * @memberof GetCorporationsCorporationIdMedals200Ok
     */
    title: string;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdMedals200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdMedals200Ok(value: object): value is GetCorporationsCorporationIdMedals200Ok {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('creatorId' in value) || value['creatorId'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('medalId' in value) || value['medalId'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdMedals200OkFromJSON(json: any): GetCorporationsCorporationIdMedals200Ok {
    return GetCorporationsCorporationIdMedals200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdMedals200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdMedals200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['created_at'])),
        'creatorId': json['creator_id'],
        'description': json['description'],
        'medalId': json['medal_id'],
        'title': json['title'],
    };
}

export function GetCorporationsCorporationIdMedals200OkToJSON(json: any): GetCorporationsCorporationIdMedals200Ok {
    return GetCorporationsCorporationIdMedals200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdMedals200OkToJSONTyped(value?: GetCorporationsCorporationIdMedals200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created_at': ((value['createdAt']).toISOString()),
        'creator_id': value['creatorId'],
        'description': value['description'],
        'medal_id': value['medalId'],
        'title': value['title'],
    };
}

